import { AxiosError } from 'axios';

export const API_PREFIX = '/api';
export const API_PREFIX_V2 = '/api/v2';
export const API_PREFIX_ADMIN = '/admin';
export const ME_LOCAL_STORAGE_KEY = 'me';

export { AxiosError };
